// Main constants file to override
import constants from './constants.base'

// Ovverride for development
if (process.env.NODE_ENV === 'development') {
  // Must use nginx proxy in local, see readme.md in config folder
  // Use IP to access your dev environment from another computer. User localhost istead.
  constants.baseUrl = window.location.protocol + '//192.168.5.13'
  // constants.baseUrl = window.location.protocol + '//localhost'
  constants.gmsUrl = constants.baseUrl + '/gms'
  constants.docsUrl = 'http://localhost:8090/docs'
  constants.remoteShellUrl = window.location.protocol + '//localhost'
}

// Ovverride for production
if (process.env.NODE_ENV === 'production') {
  constants.baseUrl = window.location.protocol + '//%%WMC_DASHBOARD_HOST%%'
  constants.gmsUrl = constants.baseUrl + '/gms'
  constants.docsUrl = constants.baseUrl + '/docs'
  constants.remoteShellUrl = window.location.protocol + '//%%WMC_DASHBOARD_HOST%%'
}

// Export constants
export default constants
